module.exports = __webpack_public_path__ + "img/symbol_0.3ca130e7.png";